import type { FaireProductEntity } from "../../entity_types/product";

export const p_83wswydtu4: FaireProductEntity = {
  token: "p_83wswydtu4",
  type: "product",
  name: "MEN'S HORMONE SUPPORT | 10 ml",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/725d32d7f98a4507ac3abb22ab4deae017b367bc19dfc4ba0ab0f47ddd9667ce.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4293a237c2a67a0d0fb72eeda5204f021f2b431991e1c755ec9760f09e2c63fa.png",
  ],
  priceDollars: 23.1,
  description:
    "\nThis 100% pure, therapeutic grade essential oil hormone support blend boosts performance and increases energy and stamina naturally. This blend helps men maintain healthy levels of testosterone and balances supporting hormones needed for them to be their strongest self.\nFor more product information or questions on products, please join our VIP group on Facebook. ",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:42.800Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
